import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // base_path = `http://localhost:8888/lrfund/`;
  base_path = 'https://ogc.mapedia.co.th/api/v1/lrfund/';
  master_year: any = [];
  list_id_province: any = [];
  fiscal_year = [2548, 2549, 2550, 2551, 2552, 2553, 2554, 2555, 2556, 2557, 2558, 2559,
    2560, 2561, 2562, 2563, 2564, 2565, 2566, 2567, 2568, 2569,
    2570, 2571, 2572, 2573, 2574, 2575, 2576, 2577, 2578, 2579,
    2580, 2581, 2582, 2583, 2584, 2585, 2586, 2587, 2588, 2589]
  month = [{ en: `jan`, th: `มกราคม` }, { en: `feb`, th: `กุมภาพันธ์` }, { en: `mar`, th: `มีนาคม` }, { en: `apr`, th: `เมษายน` }, { en: `may`, th: `พฤษภาคม` },
  { en: `jun`, th: `มิถุนายน` }, { en: `jul`, th: `กรกฎาคม` }, { en: `aug`, th: `สิงหาคม` }, { en: `sep`, th: `กันยายน` },
  { en: `oct`, th: `ตุลาคม` }, { en: `nov`, th: `พฤศจิกายน` }, { en: `dec`, th: `ธันวาคม` }]
  constructor(public http: HttpClient) {
    this.get_year().then((res: any) => {
      this.master_year = res;
    })
    this.id_province().then((res: any) => {
      this.list_id_province = res;
    })
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  get_year() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}view_data.php?type=master_year`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  id_province() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}/general/view_data_new.php?type=id_province`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  //function
  startPage() {
    if (!localStorage.getItem(`foo`)) {
      localStorage.setItem(`foo`, `no reload`)
      location.reload()
    } else {
      localStorage.removeItem(`foo`)
    }
  }
  maximizeorMinimize(table_name: any, btn_name: any, maximized_status: boolean) {
    var table = document.getElementById(table_name);
    var btn = document.getElementById(btn_name);
    if (!maximized_status) {
      table!.style.position = `fixed`;
      table!.style.zIndex = `99`;
      table!.style.background = `white`;
      table!.style.width = "100vw";
      table!.style.height = "90vh";
      table!.style.top = "12%";
      table!.style.left = "0";
      btn!.setAttribute(`src`, "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEX///8AAADo6OgwMDB0dHTCwsI3NzdwcHAgICDU1NRhYWGWlpZLS0va2tqSkpLHx8e5ublZWVknJyfe3t5BQUGjo6NmZmYXFxf19fVTU1NcXFympqavr68YGBgODg62trZ7e3vm1eqLAAACtUlEQVR4nO3d7VLiQBBGYT5CICQIsqIssuj9X+UWtaXlTK2ka7rdd9Y6zwUMc0xiBn/YkwkAAAAAAAAAAMB/aNs3QzvXaoem335N3mI9rcd6Ed53uKijMpdDaF+3Ugf9xX4TF3injvlEHxVY0wOYeowJfFB33DBEBNZ7Ba8CrmKtz+Ab97PYqQtGeX+j7tUBo1pf4LN6/wZnV6F69xYrT+CLevcmnjPqkC922nUzrW53n29qXR54zJba/3D8tOJs8lNy+VKLdKHVMW6XLsfsi05XvFL2tq/jCl5lb+nyt356YHPc7uF+Jjt7LV6nTdbZhe3P75zsrPz8Pa/0Js1v0/JjTVo4C9yh1yzZ2bx4HQp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCK3tht4h367+S/vvC5TTesqrC5gsKGwoppJBCCimkkEIKgwu//7n0sGyiLW8NVuP7oRWFOhRaUahDoRWFOhRaUahDoRWFOhRaUahDoRWFOlGF6YRH73joSJtkZ+XzD9O58S+BO/RKBxU/FK+T/p33FLhDr3Qm8K2/Hd/WJ+tUNKYzvUkds2S36UL1zAN+Sje2LV8qXegbznTOxu5OK53Lfe8o3OWLVckzW31yGV9f7pcnMJudXKezq3CyV+9/VPmR7Y9u/CPE3IfJu/HPkCp/279bj3+K0KM/MD9/16V8bnyi3qsYcgWvan0WA57BN11+EqzBPvYr+UHdk3t6Du272p3UUR+sXWfRz237ZmjnWu3Q9I7vgwAAAAAAAAAAADq/AeDROLr9IlTcAAAAAElFTkSuQmCC");
      btn!.style.width = "30px";
      btn!.style.height = "30px";
      btn!.style.marginRight = "15px";
      btn!.title = "Minimize";
      maximized_status = true;
    } else {
      table!.style.position = `relative`;
      table!.style.zIndex = `5`;
      table!.style.width = "100%";
      table!.style.height = "auto";
      table!.style.top = "0%";
      btn!.title = "Maximize";
      btn!.style.width = "15px";
      btn!.style.height = "15px";
      btn!.style.marginRight = "0px";
      btn!.setAttribute(`src`, "https://cdn2.iconfinder.com/data/icons/mixed-vol-7/74/Untitled-1-11-08-07-17-512.png");
      maximized_status = false;
    }
  }
  switchMaximize(data: any) {
    if (!data) {
      data = true
    } else {
      data = false
    }
    return data
  }

  //api
  async login_user(data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}province_fund.php?type=query_user`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async get(table: any) {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}read.php?table=${table}`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async getById(table: any, id: number) {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}readById.php?table=${table}&id=${id}`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async getByType(type: any) {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}readByType.php?type=${type}`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async create(table: any, data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}write.php?table=${table}`, JSON.stringify(data), this.httpOptions)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async uploadFile(table: any, data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}write.php?table=${table}`, data)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async update(table: any, id: number, data: any) {
    return new Promise((res, rej) => {
      this.http.put(`${this.base_path}update.php?table=${table}&id=${id}`, JSON.stringify(data), this.httpOptions)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async delete(table: any, id: number) {
    return new Promise((res, rej) => {
      this.http.delete(`${this.base_path}delete.php?table=${table}&id=${id}`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  getProvince() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}province_fund.php?type=amount_receive_province`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  getYear() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}province_fund.php?type=view_year`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  get_all_funding() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}province_fund.php?type=view_all_funding`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  get_all_newproject() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}newproject.php?type=allnew_project`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async query_image_data(data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}province_fund.php?type=query_image_data`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async query_province_data(data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}province_fund.php?type=query_province_data`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async view_geojson_file() {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}view_geojson_file.php?type=view_all_geojson`, JSON.stringify(`x`))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  async view_geojson_file2() {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}province_fund.php?type=view_all_geojson2`, JSON.stringify(`x`))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  get_tbnamelist() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}proj_ws.php?type=tb_namelist`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }


  getTopicIndicators() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}general/view_data_new.php?type=topic_indicators`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  getDatatable(id: any, year: any) {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}general/view_data_new.php?type=datatable&id=${id}&year=${year}`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  update_master_table(data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}general/update_data.php?type=update_master_table`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  update_value(data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}general/update_data.php?type=update_value`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  remove_year(data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}general/update_data.php?type=remove_year`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  remove_topic(data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}general/update_data.php?type=remove_topic`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  getIndicators() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}general/view_data.php?type=indicators`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  async query_meeting_data(data: any) {
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}province_fund.php?type=query_meeting_data`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  getgprogress() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}province_fund.php?type=view_progress`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  g_Pindi() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}general/view_data.php?type=g_indicator_pdf`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  year_leave() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}general/view_data.php?type=lev_year`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
  get_parcel_demo() {
    return {
      "type": "FeatureCollection",
      "name": "parcel_workshop",
      "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
      "features": [
        { "type": "Feature", "properties": { "rowid": 1102.0, "zone_id": "06", "block_id": "A", "lot": "132", "parcel_cod": "06A132", "mapsheet": "5143IV6210-1", "land_no": "348", "survey": "5143IV6210-1\/348", "land_type": "สปก 4-01", "scale": "4000", "link_g": "5143IV6210-1\/348", "idx": "302", "ldoc_name": "ส.ป.ก.4-01", "ldoc_type": "6", "dn": null, "rw": "5143IV6210-1", "rwa": null, "apn": null, "app": null, "ln": "348", "sn": null, "rai": "0", "ngan": "2", "wa": "73.0", "sc": "4000", "line_no": "302", "owner_type": "1", "title": "25", "codept4": "ช950\/2551", "pop_id": "3650300229355", "title_name": "นาย", "first_name": "ชอบ", "last_name": "จันทะคุณ", "address": "20", "moo": "12", "soi": null, "road": null, "tambon": "ป่าแดง", "amphoe": "ชาติตระการ", "province": "พิษณุโลก", "tambon_id": "650301", "amphoe_id": "6503", "province_i": "65", "zipcode": "65170", "telephone": null, "l_moo": "12", "l_tambon": "ป่าแดง", "l_amphoe": "ชาติตระการ", "l_province": "พิษณุโลก", "l_tambon_i": "650301", "l_amphoe_i": "6503", "l_provin_1": "65", "l_zipcode": "65170", "land_value": null, "wa_price": null, "mo": 12, "sub": "นาย", "fname": "ชอบ", "lname": "จันทะคุณ", "id_card": "3650300229355" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[100.52477285137752, 17.287163590513806], [100.5249073213391, 17.287038818229902], [100.52476662073812, 17.286886512688032], [100.524597238961064, 17.286534643790503], [100.524480193505937, 17.28663556951048], [100.52477285137752, 17.287163590513806]]]] } },
        { "type": "Feature", "properties": { "rowid": 1104.0, "zone_id": "06", "block_id": "A", "lot": "134", "parcel_cod": "06A134", "mapsheet": "5143IV6210-1", "land_no": "350", "survey": "5143IV6210-1\/350", "land_type": "สปก 4-01", "scale": "4000", "link_g": "5143IV6210-1\/350", "idx": "304", "ldoc_name": "ส.ป.ก.4-01", "ldoc_type": "6", "dn": null, "rw": "5143IV6210-1", "rwa": null, "apn": null, "app": null, "ln": "350", "sn": null, "rai": "0", "ngan": "2", "wa": "68.0", "sc": "4000", "line_no": "304", "owner_type": "1", "title": "23", "codept4": "ช470\/8171", "pop_id": "1650300011698", "title_name": "นาง", "first_name": "ชุติมา", "last_name": "สุโคมุค", "address": "19", "moo": "12", "soi": null, "road": null, "tambon": "ป่าแดง", "amphoe": "ชาติตระการ", "province": "พิษณุโลก", "tambon_id": "650301", "amphoe_id": "6503", "province_i": "65", "zipcode": "65170", "telephone": null, "l_moo": "12", "l_tambon": "ป่าแดง", "l_amphoe": "ชาติตระการ", "l_province": "พิษณุโลก", "l_tambon_i": "650301", "l_amphoe_i": "6503", "l_provin_1": "65", "l_zipcode": "65170", "land_value": null, "wa_price": null, "mo": 12, "sub": "นาง", "fname": "ชุติมา", "lname": "สุโคมุค", "id_card": "1650300011698" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[100.52474348063285, 17.286414433786707], [100.524597229617925, 17.286534662103005], [100.524766574247636, 17.286886631611161], [100.524989112686598, 17.286651558560024], [100.52474348063285, 17.286414433786707]]]] } },
        { "type": "Feature", "properties": { "rowid": 1147.0, "zone_id": "06", "block_id": "A", "lot": "176", "parcel_cod": "06A176", "mapsheet": "5143IV6210-5", "land_no": "418", "survey": "5143IV6210-5\/418", "land_type": "สปก 4-01", "scale": "4000", "link_g": "5143IV6210-5\/418", "idx": "31", "ldoc_name": "ส.ป.ก.4-01", "ldoc_type": "6", "dn": null, "rw": "5143IV6210-5", "rwa": null, "apn": null, "app": null, "ln": "418", "sn": null, "rai": "0", "ngan": "1", "wa": "28.0", "sc": "4000", "line_no": "31", "owner_type": "1", "title": "25", "codept4": "น000\/7744", "pop_id": "3650300228073", "title_name": "นาย", "first_name": "นำ", "last_name": "มูลติ๊ด", "address": "2", "moo": "12", "soi": null, "road": null, "tambon": "ป่าแดง", "amphoe": "ชาติตระการ", "province": "พิษณุโลก", "tambon_id": "650301", "amphoe_id": "6503", "province_i": "65", "zipcode": "65170", "telephone": null, "l_moo": "12", "l_tambon": "ป่าแดง", "l_amphoe": "ชาติตระการ", "l_province": "พิษณุโลก", "l_tambon_i": "650301", "l_amphoe_i": "6503", "l_provin_1": "65", "l_zipcode": "65170", "land_value": null, "wa_price": null, "mo": 12, "sub": "นาย", "fname": "นำ", "lname": "มูลติ๊ด", "id_card": "3650300228146" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[100.524225456223348, 17.285211477575711], [100.524138375131187, 17.285271022593317], [100.524390891410519, 17.285596248173643], [100.524447664461675, 17.28556854583627], [100.524484011526539, 17.285548345424512], [100.524225456223348, 17.285211477575711]]]] } },
        { "type": "Feature", "properties": { "rowid": 1148.0, "zone_id": "06", "block_id": "A", "lot": "177", "parcel_cod": "06A177", "mapsheet": "5143IV6210-5", "land_no": "419", "survey": "5143IV6210-5\/419", "land_type": "สปก 4-01", "scale": "4000", "link_g": "5143IV6210-5\/419", "idx": "277", "ldoc_name": "ส.ป.ก.4-01", "ldoc_type": "6", "dn": null, "rw": "5143IV6210-5", "rwa": null, "apn": null, "app": null, "ln": "419", "sn": null, "rai": "1", "ngan": "0", "wa": "79.0", "sc": "4000", "line_no": "277", "owner_type": "1", "title": "23", "codept4": "บ300\/6776\/001", "pop_id": "3650300228162", "title_name": "นาง", "first_name": "บุญ", "last_name": "พรมภาพ", "address": "3", "moo": "12", "soi": null, "road": null, "tambon": "ป่าแดง", "amphoe": "ชาติตระการ", "province": "พิษณุโลก", "tambon_id": "650301", "amphoe_id": "6503", "province_i": "65", "zipcode": "65170", "telephone": null, "l_moo": "12", "l_tambon": "ป่าแดง", "l_amphoe": "ชาติตระการ", "l_province": "พิษณุโลก", "l_tambon_i": "650301", "l_amphoe_i": "6503", "l_provin_1": "65", "l_zipcode": "65170", "land_value": null, "wa_price": null, "mo": 12, "sub": "นาง", "fname": "บุญ", "lname": "พรมภาพ", "id_card": "3650300228162" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[100.524462491225606, 17.285083755891549], [100.524225362041534, 17.285211569498646], [100.524483973290813, 17.285548313792315], [100.524582175687328, 17.285497330619293], [100.524787728708915, 17.285332644123304], [100.524877798159508, 17.285213467396453], [100.524462491225606, 17.285083755891549]]]] } },
        { "type": "Feature", "properties": { "rowid": 1857.0, "zone_id": "02", "block_id": "E", "lot": "018", "parcel_cod": "02E018", "mapsheet": "2405", "land_no": "20", "survey": "2405\/20", "land_type": "ส.ป.ก.4-01", "scale": "4000", "link_g": "2405\/20", "idx": "627", "ldoc_name": "ส.ป.ก.4-01", "ldoc_type": "6", "dn": null, "rw": "2405", "rwa": null, "apn": null, "app": null, "ln": "20", "sn": null, "rai": "1", "ngan": "1", "wa": "11.0", "sc": "4000", "line_no": "627", "owner_type": "1", "title": "23", "codept4": "พ500\/7550", "pop_id": "3650300229487", "title_name": "นาง", "first_name": "พาน", "last_name": "วุทธา", "address": "23", "moo": "12", "soi": null, "road": null, "tambon": "ป่าแดง", "amphoe": "ชาติตระการ", "province": "พิษณุโลก", "tambon_id": "650301", "amphoe_id": "6503", "province_i": "65", "zipcode": "65170", "telephone": null, "l_moo": "12", "l_tambon": "ป่าแดง", "l_amphoe": "ชาติตระการ", "l_province": "พิษณุโลก", "l_tambon_i": "650301", "l_amphoe_i": "6503", "l_provin_1": "65", "l_zipcode": "65170", "land_value": null, "wa_price": null, "mo": 12, "sub": "นาง", "fname": "พาน", "lname": "วุทธา", "id_card": "3650300229487" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[100.524593164496437, 17.28731926615982], [100.524772875135142, 17.287163159103365], [100.524427475317935, 17.286540580909929], [100.524205432367651, 17.286655000734306], [100.524593164496437, 17.28731926615982]]]] } }
      ]
    }
  }

  view_funding() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}province_fund.php?type=view_funding`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  avg_score() {
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}general/view_data_new.php?type=avg_score`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  async add_indicators(data: any) {
    // console.log(data);
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}general/insert_data.php?type=ins_result`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  async update_score(data: any) {
    // console.log(data);
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}general/update_data.php?type=update_score`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  async del_Indi(data: any) {
    // console.log(data);
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}general/delete_pdf.php?type=del_g_indicator_pdf`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  async upload_file(data: any) {
    // console.log(data);
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}write.php?table=image_upload`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  async project_file_image(project_id: any) {
    // console.log(data);
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}view_data.php?type=project_file_image&id=${project_id}`)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  async project_location(data: any) {
    // console.log(data);
    return new Promise((res, rej) => {
      this.http.post(`${this.base_path}general/update_data.php?type=project_location`, JSON.stringify(data))
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }

  async location_project(id_province: any) {
    // console.log(data);
    return new Promise((res, rej) => {
      this.http.get(`${this.base_path}general/view_data_new.php?type=location_project&id=${id_province}`,)
        .subscribe((data: any) => {
          res(data)
        }, (err: any) => {
          rej(err)
        });
    });
  }
}
